//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PID.js";
import "../no/Builder.js";
import "../no/PDM.js";
import "../no/Diagramming.js";
let d=[[[0,"ExistingSymbol",1,"Diagramming.Port",0],[0,"Label",0,0],[0,"LockAspectRatio",1,0],[0,"NeedAttrOwner",0,"NXObject",0],[0,"OwningSheet",1,"PID.Sheet",0],[0,"PortId",1,0],[0,"RelativePercentX",1,0],[0,"RelativePercentY",1,0],[0,"RelativeValueX",1,0],[0,"RelativeValueY",1,0],[0,"Scale",1,0],[0,"ScaleX",1,0],[0,"ScaleY",1,0],[0,"SymbolId",1,0],[0,"SymbolSourceType",1,0],[0,"UseExistingID",1,0]],[[["equipment","nodeId"],"GetNode",{},0,0],[["equipment","nodeId"],"SetNode",{},2,0],[[],"GetPort",{R_:{port:"Diagramming.Port"}},0,0],[["symbolID"],"SetFulfillment",{},1,0]],[]];
SPLM.PID.PortEquipmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PID.PortEquipmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;